module.exports = __webpack_public_path__ + "static/img/cont32_09.2537f16.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont32_09.jpg
// module id = In++
// module chunks = 0